import React from "react";
import VerifyIdentity from "./verifyIdentity";
import OTPVerification from "./OTPVerification";
import ChooseVerificationMethod from "../chooseVerificationMethod";
import { decodeJwt } from "../helpers";
import ConfirmBankVerification from "./OTPVerification/ConfirmBankVerification";
import { ONBOARDING_SESSION_TYPE_ID } from "../constants";

function Identification({
  onboardingSessionTypeId = ONBOARDING_SESSION_TYPE_ID.piOnboarding,
}) {
  const searchParams = new URLSearchParams(window.location.search);
  const step = searchParams.get("step");

  const onboardingToken = sessionStorage.getItem("onboardingToken");

  if (!onboardingToken) {
    return (
      <VerifyIdentity onboardingSessionTypeId={onboardingSessionTypeId} />
    );
  }

  const payload = decodeJwt(onboardingToken);

  if (step === "verification-method") {
    return (
      <ChooseVerificationMethod
        onboardingSessionTypeId={onboardingSessionTypeId}
      />
    );
  }

  if (step === "otp-verification") {
    return (
      <OTPVerification
        otpInfo={{
          otpResendSeconds: payload?.OtpResendSeconds,
          mobileNumberMask: payload?.mobileNumberMask,
        }}
      />
    );
  }

  if (step === "confirm-code") {
    return (
      <ConfirmBankVerification
        otpInfo={{
          otpResendSeconds: payload?.OtpResendSeconds,
          mobileNumberMask: payload?.mobileNumberMask,
        }}
      />
    );
  }

  return <VerifyIdentity onboardingSessionTypeId={onboardingSessionTypeId} />;
}

export default Identification;
